import React, { useContext, useState } from "react";
import Tablecomp from "../comp/Table";
import { contextData } from "../Context";
import { MdDeleteOutline } from "react-icons/md";
import axios from "axios";
import { toast } from "react-toastify";


const ContactList = () => {
  const { contactData, setContactData } = useContext(contextData);
  

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  });

   const deleteContact = async (id) => {
    try {
      const confirmDelete = window.confirm(
        "Are you sure you want to delete this user?"
      );
      if (!confirmDelete) return;

      await axios.delete(
        `${process.env.REACT_APP_PORT_BACKEND}contact/deletecontact?cId=${id}`
      );

      setContactData((prevData) => prevData.filter((item) => item.id !== id));
      toast.success("Contact has been deleted");
    } catch (error) {
      console.log(error);
    }
  };

  const columnConfig = [
    {
      title: "Sr no.",
      dataIndex: "srno",
      key: "srno",
      render:(text, record, index) => 
        (pagination.current - 1) * pagination.pageSize + index + 1,
    },
    {
      title: "First Name",
      dataIndex: "firstName",
      key: "firstName",
      isSearchable: true,
    },
    {
      title: "Last Name",
      dataIndex: "lastName",
      key: "lastName",
      isSearchable: true,
    },
    
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      isSearchable: true,
    },
    {
      title: "Contact",
      dataIndex: "contact",
      key: "contact",
      isSearchable: true,
    },
    {
      title: "Message",
      dataIndex: "message",
      key: "message",
      isSearchable: true,
      render: (_, record) => (
        <div className="action_btn" style={{ display: "flex", gap: "10px" }}>
          <textarea disabled>{record.message}</textarea>
        </div>
      ),
    },
    {
      title: "Date & Time",
      dataIndex: "creationDate",
      key: "creationDate",
      isSearchable: true,
    },

     {
          title: "Action",
          dataIndex: "action",
          key: "action",
          render: (_, record) => (
            <div className="action_btn" style={{ display: "flex", gap: "10px" }}>
              <button className="table_btn" onClick={() => deleteContact(record.cid)}>
                <MdDeleteOutline />
              </button>
              
            </div>
          ),
        },
  ];

  return (
    <>
      <Tablecomp columnConfig={columnConfig} tableData={contactData || []} />
    </>
  );
};

export default ContactList;
